import { useEffect, useRef, useState } from "react";
import { getConsentStatus, setConsentStatus } from "./CookieConsent";


interface LazyYouTubeProps {
  videoId: string;
  title: string;
  className?: string;
  style?: React.CSSProperties;
}

const LazyYouTube = ({ videoId, title, className, style }: LazyYouTubeProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [consent, setConsent] = useState(getConsentStatus());
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handler = () => setConsent(getConsentStatus());
    window.addEventListener("cookie-consent-change", handler);
    return () => window.removeEventListener("cookie-consent-change", handler);
  }, []);

  const src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&disablekb=1&fs=0&iv_load_policy=3`;

  const showVideo = isVisible && consent === "granted";

  return (
    <div ref={containerRef} className={className} style={style}>
      {showVideo ? (
        <iframe
          src={src}
          title={title}
          className="w-full h-full"
          style={{ border: 0 }}
          allow="autoplay; encrypted-media"
          loading="lazy"
          allowFullScreen
        />
      ) : (
        <div className="w-full h-full bg-black flex flex-col items-center justify-center gap-3 p-4 text-center">
          {isVisible && consent !== "granted" && (
            <>
              <p className="font-[Montserrat] text-xs text-foreground/50 normal-case tracking-normal">
                Video wird erst nach Zustimmung von YouTube geladen.
              </p>
              <button
                type="button"
                onClick={() => setConsentStatus("granted")}
                className="px-4 py-2 bg-primary text-primary-foreground font-[Montserrat] text-[10px] tracking-[0.15em] uppercase rounded hover:bg-primary/90 transition-colors"
              >
                Video laden
              </button>
            </>
          )}
        </div>
      )}

    </div>
  );
};

export default LazyYouTube;
